"use client"
import * as React from "react"
import { useTheme } from "@mui/material/styles"
import Box from "@mui/material/Box"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Chip from "@mui/material/Chip"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { SparkLineChart } from "@mui/x-charts/SparkLineChart"
import { areaElementClasses } from "@mui/x-charts/LineChart"

function getDaysInMonth(month, year) {
    const date = new Date(year, month, 0)
    const monthName = date.toLocaleDateString("en-US", {
        month: "short"
    })
    const daysInMonth = date.getDate()
    const days = []
    let i = 1
    while (days.length < daysInMonth) {
        days.push(`${monthName} ${i}`)
        i += 1
    }
    return days
}

function AreaGradient({ color, id }) {
    return (
        <defs>
            <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
                <stop offset="0%" stopColor={color} stopOpacity={0.3} />
                <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
        </defs>
    )
}

export default function StatCard({ title, value, interval, trend, data }) {
    const theme = useTheme()
    return (
        <Card variant="outlined" sx={{ height: "100%", flexGrow: 1 }}>
            <CardContent>
                <Typography component="h2" variant="subtitle2" gutterBottom>
                    {title}
                </Typography>
                <Stack
                    direction="column"
                    sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
                >
                    <Stack sx={{ justifyContent: "space-between" }}>
                        <Stack
                            direction="row"
                            sx={{ justifyContent: "space-between", alignItems: "center" }}
                        >
                            <Typography variant="h4" component="p">
                                {value}
                            </Typography>
                        </Stack>
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                            {interval}
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )
}
